import { useParams } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import HStack from '@/components/Layout/HStack';
import { useGetGroupId } from '@/routes/_staff/ids/-api';
import { DetailContent } from './-components/DetailContent';
import { InnerNavigation } from './-components/InnerNavigation';
export const Route = createFileRoute('/_staff/ids/group-id/$id/_$id/detail/')({
  component: Detail
});
function Detail() {
  const {
    id: proxyUserId
  } = useParams({
    from: '/_staff/ids/group-id/$id/_$id/detail/'
  });
  const {
    data
  } = useGetGroupId(proxyUserId);
  return <HStack className="gap-10 px-12 py-6">
      {/* Left Rail: Navigation */}
      <nav className="sticky top-6 h-fit w-60 shrink-0">
        <InnerNavigation />
      </nav>

      {/* Content */}
      <div className="flex-1 pb-24">
        <DetailContent groupId={data} />
      </div>
    </HStack>;
}